'use strict'

import Utils from '../Utils'

function csrfToken() {
    const el = document.querySelector('meta[name="csrf-token"]')
    return el ? el.getAttribute('content') : ''
}

async function handle(res) {
    if (!res.ok) {
        const err = new Error(`HTTP ${res.status}`)
        err.status = res.status
        // Try to attach server message if any
        try {
            err.body = await res.json()
        } catch {
            // ignore
        }
        throw err
    }
    // Some endpoints may return empty 204
    if (res.status === 204) return null
    return res.json()
}

function postJSON(url, body) {
    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': csrfToken(),
        },
        body: JSON.stringify(body),
        credentials: 'same-origin',
    }).then(handle)
}

function getJSON(url) {
    return fetch(url, {
        method: 'GET',
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
    }).then(handle)
}

const SwatchAPI = {
    // Get SwatchColor, SwatchPage, Swatch
    getSwatchColor(serverID, swatchColorCode) {
        // POST /project/colorfromServerIdandName
        return postJSON('/swatches/' + serverID + '/find-color', {
            name: swatchColorCode,
        })
    },

    // Get TextureSwatch (+ TexturePage + Texture)
    getTextureSwatch(textureName) {
        // Logs kept to mirror your current behavior
        console.info('getTextureSwatch: ' + textureName)

        return postJSON('/texture-swatches/find-texture-by-page-and-name', {
            texture_name: textureName,
        })
    },

    // Get closest SwatchColor for given RGB and swatch_id
    getClosestColor(swatchColorInfos, swatch_id) {
        const rgb = Utils.rgbFromInfos(swatchColorInfos)
        return postJSON(`/swatches/${swatch_id}/find-closest-color`, {
            serverid: parseInt(swatch_id, 10),
            color: {
                _sr: rgb.r,
                _sg: rgb.g,
                _sb: rgb.b,
            },
        })
    },

    // Get closest colors across all available swatches (visible + invisible).
    getClosestColors(rgb) {
        return postJSON('/swatches/closest-colors', {
            color: {
                _sr: rgb.r,
                _sg: rgb.g,
                _sb: rgb.b,
            },
        })
    },

    getClosestColorwithServerIDandColor(serverID, color) {
        return postJSON(`/swatches/${serverID}/find-closest-color`, {
            serverid: parseInt(serverID, 10),
            color: {
                _sr: color[0],
                _sg: color[1],
                _sb: color[2],
            },
        })
    },

    get_swatch(serverID) {
        return getJSON(`/swatches/${serverID}`)
    },

    get_texture_swatch(serverID) {
        return getJSON(`/texture-swatches/${serverID}`)
    },
}

export default SwatchAPI
